import React, { useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { 
    LayoutDashboard, 
    UserCheck, 
    UserPlus,
    Users, 
    Store, 
    Lock, 
    CreditCard, 
    Handshake,
    Instagram,
    LogOut, 
    Menu, 
    X,
} from 'lucide-react';
import '../admin/AdminStyles.scss';

const AdminLayout = () => {
    const { currentUser, logout } = useAuth();
    const navigate = useNavigate();
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const handleLogout = async () => {
        await logout();
        navigate('/login');
    };

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    const NavItem = ({ to, icon: Icon, label }) => (
        <NavLink
            to={to}
            className={({ isActive }) => `dashboard-view__menu-item ${isActive ? 'is-active' : ''}`}
            onClick={() => setSidebarOpen(false)}
            end
        >
            <Icon className="dashboard-view__menu-icon" />
            <span className="dashboard-view__menu-label">{label}</span>
        </NavLink>
    );

    return (
        <div className="dashboard-view">
            <div className="dashboard-view__layout">
                {/* Mobile Header */}
                <header className="mobile-header">
                    <button className="sidebar-toggle" type="button" onClick={toggleSidebar} aria-label={sidebarOpen ? 'Cerrar navegación' : 'Abrir navegación'} aria-expanded={sidebarOpen} aria-controls="admin-sidebar">
                        {sidebarOpen ? <X size={24} /> : <Menu size={24} />}
                    </button>
                    <div className="dashboard-view__logo">FOTH</div>
                </header>

                {/* Sidebar Overlay for Mobile */}
                {sidebarOpen && (
                    <div className="sidebar-overlay" role="presentation" onClick={toggleSidebar}></div>
                )}

                {/* Sidebar Navigation */}
                <aside id="admin-sidebar" aria-label="Navegación de administración" className={`dashboard-view__sidebar ${sidebarOpen ? 'is-open' : ''}`}>
                    <div className="dashboard-view__sidebar-header">
                        <div className="dashboard-view__logo">
                            FOTH<span className="dashboard-view__logo-accent">.</span>
                        </div>
                        <div className="dashboard-view__console-label">PLATFORM CONSOLE</div>
                    </div>

                    <nav className="dashboard-view__sidebar-body" aria-label="Secciones de la consola">
                        <div className="dashboard-view__menu-group">
                            <NavItem to="/console/dashboard" icon={LayoutDashboard} label="Dashboard" />
                        </div>

                        <div className="dashboard-view__menu-group">
                            <h4 className="dashboard-view__menu-title">Verificaciones</h4>
                            <div className="dashboard-view__menu-list">
                            <NavItem to="/console/business-verifications" icon={Store} label="Marcas" />
                                <NavItem to="/console/creator-verifications" icon={UserCheck} label="Creadores" />
                                <NavItem to="/console/invited-creators" icon={UserPlus} label="Invitados" />
                            </div>
                        </div>

                        <div className="dashboard-view__menu-group">
                            <h4 className="dashboard-view__menu-title">Gestión</h4>
                            <div className="dashboard-view__menu-list">
                                <NavItem to="/console/users" icon={Users} label="Usuarios" />
                                <NavItem to="/console/plans" icon={Lock} label="Planes" />
                                <NavItem to="/console/sellers" icon={Handshake} label="Vendedores" />
                                <NavItem to="/console/payments" icon={CreditCard} label="Transacciones" />
                            </div>
                        </div>

                        <div className="dashboard-view__menu-group">
                            <h4 className="dashboard-view__menu-title">Operaciones</h4>
                            <div className="dashboard-view__menu-list">
                                <NavItem to="/console/meta" icon={Instagram} label="Meta & Instagram" />
                            </div>
                        </div>
                    </nav>

                    <div className="dashboard-view__sidebar-footer">
                        <div className="dashboard-view__user-info">
                            <span className="dashboard-view__user-name">{currentUser?.username || 'Admin'}</span>
                            <span className="dashboard-view__user-role">{currentUser?.is_superuser ? 'Superusuario' : 'Staff'}</span>
                        </div>
                        <button className="dashboard-view__logout" onClick={handleLogout}>
                            <LogOut size={16} /> Salir de la consola
                        </button>
                    </div>
                </aside>

                {/* Main Content Area */}
                <main className="dashboard-view__main">
                    <Outlet />
                </main>
            </div>
        </div>
    );
};

export default AdminLayout;
